import { RuleCheckItem, RuleCheckResult } from './types';

const evaluateMethod = (method, params) => {
  switch (method) {
    case 'greaterThan': {
      return params[0] > params[1];
    }
    case 'and': {
      return !params.some((value) => value !== true);
    }
  }
  console.error(`Unknown method: ${method}`);
  return true;
};

export const checkRule = (
  rule: RuleCheckItem,
  value?: string | { [key: string]: string }
): boolean | RuleCheckResult => {
  const { method, params, errorMessage, result = true } = rule;
  const mappedParams = params.map((param) => {
    if (typeof param === 'string') {
      if (param === 'value') {
        return value;
      } else if (param.startsWith('fields.') && typeof value === 'object') {
        return value[param.replace('fields.', '')];
      }
    } else if (typeof param === 'object') {
      return checkRule(param, value);
    }
    return param;
  });
  const evaluatedResult = evaluateMethod(method, mappedParams) ? result : !result;
  return (
    evaluatedResult || {
      result: evaluatedResult,
      errorMessage,
      params: params.reduce((res, param, idx) => ({ ...res, [`param${idx + 1}`]: param }), {}),
    }
  );
};
